module.exports = "/lucky-balls/img/infobox/info_Box_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_005.png
// module id = 1070
// module chunks = 0